// Top-of-screen warning banner that surfaces Clio token health.
// Polls /api/token-health every 5 minutes; renders only when the
// token is in a non-healthy state (e.g., expiring soon, expired,
// revoked). Auto-dismissable for warnings; expired tokens force a
// reconnect link.

import React, { useState, useEffect } from "react";
import { useIsMobile } from "../useIsMobile.js";
import { TOP_BAR_HEIGHT } from "./TopBar.jsx";

export function ConnectionBanner() {
  const [health, setHealth] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let timer;
    const check = async () => {
      try {
        const resp = await fetch("/api/token-health");
        if (resp.ok) setHealth(await resp.json());
      } catch (e) { /* ignore */ }
    };
    check();
    timer = setInterval(check, 5 * 60 * 1000); // every 5 min
    return () => clearInterval(timer);
  }, []);

  const isMobile = useIsMobile();

  if (!health || health.status === "healthy" || dismissed) return null;

  const isExpired = health.status === "expired";
  const bgColor = isExpired ? "#DC2626" : "#F59E0B";
  const textColor = isExpired ? "#fff" : "#1B2A4A";

  return React.createElement("div", {
    style: {
      // Normal flow — the parent renders it at the top of the content
      // area, so it pushes the page down instead of covering it. It was
      // fixed before, which meant it hid either the top bar or the page
      // heading depending on where it was anchored.
      position: "relative",
      background: bgColor, color: textColor,
      padding: isMobile ? "10px 14px" : "10px 24px",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      fontSize: "14px", fontWeight: 500, boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    },
  },
    React.createElement("div", { style: { display: "flex", alignItems: "center", gap: "10px" } },
      React.createElement("span", null, health.warning_message),
    ),
    React.createElement("div", { style: { display: "flex", gap: "12px", alignItems: "center" } },
      !isExpired ? React.createElement("button", {
        onClick: () => setDismissed(true),
        style: {
          background: "transparent", border: "none", color: textColor,
          cursor: "pointer", fontSize: "13px", textDecoration: "underline",
        },
      }, "Dismiss") : null,
      React.createElement("a", {
        href: "/auth/login",
        style: {
          background: isExpired ? "#fff" : "#1B2A4A", color: isExpired ? "#DC2626" : "#fff",
          padding: "6px 16px", borderRadius: "6px", textDecoration: "none",
          fontSize: "13px", fontWeight: 600,
        },
      }, isExpired ? "Reconnect Now" : "Reconnect"),
    ),
  );
}
